import {
  OPEN_SIDEBAR,
  CLOSE_SIDEBAR,
  OPEN_USER_BAR,
  CLOSE_USER_BAR,
  NAVIGATION_INIT
} from './action-types';

export function navigationReducer(state = {}, { type }) {
  switch (type) {
    case NAVIGATION_INIT:
      return Object.assign({}, state, {
        sidebar: { opened: true, closed: false },
        userbar: { opened: false, closed: true }
      });
    case OPEN_SIDEBAR:
      return Object.assign({}, state, {
        sidebar: {
          opened: true,
          closed: false
        }
      });
    case CLOSE_SIDEBAR:
      return Object.assign({}, state, {
        sidebar: {
          opened: false,
          closed: true
        }
      });
    case OPEN_USER_BAR:
      return Object.assign({}, state, {
        userbar: {
          opened: true,
          closed: false
        }
      });
    case CLOSE_USER_BAR:
      return Object.assign({}, state, {
        userbar: {
          opened: false,
          closed: true
        }
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/core/services/navigation/reducer.js